export const upcomingDateFormatted = (validFromFormatted) => {
    let date = validFromFormatted.match(/([0-3]?[0-9])\s\w+/);

    if (date) {
        return date[0].split(' ');
    }

    let day = validFromFormatted.match(/^([A-ö\w\-]+)/)[0];
    let time = validFromFormatted.match(/([0-1]?[0-9]|2[0-3]):[0-5][0-9]/)[0];

    return [day, time];
};
